export default "__VITE_ASSET__$0bjU9davHAycFjIpg2WPg__"